module.exports = __webpack_public_path__ + "static/media/b1.c9c389e6.jpg";